"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'Page404',
  computed: {
    message: function message() {
      return '您好像没有该页面的访问权限...';
    }
  }
};